import { useState } from 'react';
import { z } from 'zod';
import { Button } from '@/components/ui/button';

const BooleanSchema = z.boolean();

interface EditSaveCancelProps {
    onEdit: () => void;
    onSave: () => void;
    onCancel: () => void;
    isLoading?: boolean;
    editButtonName?: string;
    isEditing?: boolean;
}

export function EditSaveCancel({
    onEdit,
    onSave,
    onCancel,
    isLoading = false,
    editButtonName = 'Edit',
    isEditing,
}: EditSaveCancelProps) {
    const [internalEditing, setInternalEditing] = useState(false);
    const isEditingParseResult = BooleanSchema.safeParse(isEditing);
    const isControlled = isEditingParseResult.success;
    const editingState = isControlled ? isEditingParseResult.data : internalEditing;

    const handleEdit = () => {
        if (!isControlled) {
            setInternalEditing(true);
        }
        onEdit();
    };

    const handleSave = () => {
        if (!isControlled) {
            setInternalEditing(false);
        }
        onSave();
    };

    const handleCancel = () => {
        if (!isControlled) {
            setInternalEditing(false);
        }
        onCancel();
    };

    if (editingState) {
        return (
            <div className="flex gap-2">
                <Button onClick={handleSave} disabled={isLoading} size="sm">
                    {isLoading ? 'Saving...' : 'Save'}
                </Button>
                <Button onClick={handleCancel} variant="outline" disabled={isLoading} size="sm">
                    Cancel
                </Button>
            </div>
        );
    }

    return (
        <Button onClick={handleEdit} size="sm">
            {editButtonName}
        </Button>
    );
}
